import { render, staticRenderFns } from "./ManageDict.vue?vue&type=template&id=14687ace&scoped=true"
import script from "./ManageDict.vue?vue&type=script&lang=js"
export * from "./ManageDict.vue?vue&type=script&lang=js"
import style0 from "./ManageDict.vue?vue&type=style&index=0&id=14687ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14687ace",
  null
  
)

export default component.exports